import { render, staticRenderFns } from "./Auth.vue?vue&type=template&id=92ef804a&scoped=true&"
var script = {}
import style0 from "./Auth.vue?vue&type=style&index=0&id=92ef804a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92ef804a",
  null
  
)

export default component.exports